import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { OperationBasicItem } from '../../../../services/types/Operation';

interface Props {
  operations: OperationBasicItem[];
}
const FlowParentTitleWarning: React.FC<Props> = ({ operations }) => {
  const { t } = useTranslation();
  const ope = operations !== null ? operations.map((op) => op.number) : [];
  const operationNumber = ope.length > 0 ? ope.join(', ') : 's';
  return (
    <h5 className="d-flex align-items-center">
      <FontAwesomeIcon color="#fab428" icon="exclamation-triangle" />
      <span className="ml-2" style={{ color: '#787985' }}>
        {t('warningRelatedParentFlowVersion', { operationNumber })}
      </span>
    </h5>
  );
};

export default FlowParentTitleWarning;
